var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-render-post" },
    [
      _vm.music
        ? _c("AudioPlayer", {
            ref: "music-audio",
            attrs: {
              src: (this.music.track || this.music.original_sound)
                .progressive_download_url,
              start: parseInt((this.music.start || 0) / 1000),
              duration: parseInt((this.music.duration || 0) / 1000),
              loop: true,
              volume:
                !_vm.mutedSound && !_vm.modes.includes("addMusicMode")
                  ? 0.5
                  : 0,
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          ref: "render-post",
          class:
            "render-post hide-scrollbar render-post-instagram " +
            _vm.modes.join(" "),
          style: { fontSize: _vm.fontSize + "px" },
        },
        [
          _c("div", { staticClass: "header-app" }, [
            _vm._v("\n            Publication\n        "),
          ]),
          _c(
            "div",
            { staticClass: "post-content" },
            [
              _c("div", { staticClass: "post-header" }, [
                _c("div", { staticClass: "info" }, [
                  _c(
                    "div",
                    { staticClass: "img-pages" },
                    [
                      _vm._l(
                        _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
                        function (page, index) {
                          return [
                            _c(
                              "Tooltip",
                              {
                                key: index,
                                attrs: {
                                  active: page.iconEdited,
                                  text: "Voir les modifications apportées",
                                  position: "right",
                                  classCustom: `page ${
                                    page.iconEdited ? "iconEdited" : ""
                                  }`,
                                },
                                on: {
                                  click: () => {
                                    page.iconEdited
                                      ? _vm.$emit("clickPage", page.id)
                                      : _vm.openInstagramPage(page)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      page && page.avatar
                                        ? page.avatar
                                        : "img/avatar.jpg",
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                          ]
                        }
                      ),
                      _vm.pages.length > 4
                        ? _c("div", { staticClass: "page count" }, [
                            _c("p", [
                              _vm._v("+" + _vm._s(_vm.pages.length - 3)),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "info-text-header" }, [
                    _c("div", { staticClass: "container-name" }, [
                      _c("p", [
                        _vm.pages.length == 1
                          ? _c(
                              "span",
                              {
                                staticClass: "name",
                                on: {
                                  click: function ($event) {
                                    return _vm.openInstagramPage(_vm.pages[0])
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.pages[0].name) + "  ")]
                            )
                          : _vm._e(),
                        _vm.collaborators.length
                          ? _c("span", { staticClass: "collaborator" }, [
                              _vm._v("et "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.collaborators[0].name ||
                                      _vm.collaborators[0].id
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                            ])
                          : _vm._e(),
                        _c("i", { staticClass: "fa-solid fa-circle" }),
                        _c("span", { staticClass: "date" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.datePost
                                  ? _vm.formatDatePost
                                  : "A l'instant"
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm.place && _vm.place.name
                      ? _c("p", { staticClass: "location" }, [
                          _vm._v(_vm._s(_vm.place.name)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._m(0),
              ]),
              _c("div", { staticClass: "post-medias" }, [
                _c(
                  "div",
                  {
                    staticClass: "carousel",
                    class: {
                      singleMedia: _vm.medias && _vm.medias.length == 1,
                    },
                    style: {
                      "aspect-ratio": _vm.ratioCalculated
                        ? _vm.ratioCalculated.replace(":", "/")
                        : "1/1",
                    },
                    on: {
                      mousedown: _vm.mouseDownOnPost,
                      mouseup: _vm.clickOnPost,
                    },
                  },
                  [
                    _vm._l(
                      _vm.personsIdentifiedSlideCarousel,
                      function (person) {
                        return _c(
                          "div",
                          {
                            key: person.name || person.id,
                            class: `floating-tag personIndentifed ${_vm.getClassForFloatingTag(
                              person.x,
                              person.y
                            )} ${
                              _vm.showTagPersonIndentifed ? "show" : "hide"
                            }`,
                            style: {
                              left: `${person.x}%`,
                              top: `${person.y}%`,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(person.name || person.id) +
                                "\n                    "
                            ),
                          ]
                        )
                      }
                    ),
                    _vm._l(_vm.productSlideCarousel, function (product) {
                      return _c(
                        "div",
                        {
                          key: product.id,
                          class: `floating-tag product ${_vm.getClassForFloatingTag(
                            product.x,
                            product.y
                          )} ${_vm.showTagPersonIndentifed ? "show" : "hide"}`,
                          style: {
                            left: `${product.x}%`,
                            top: `${product.y}%`,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(product.text) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    _vm.medias.length
                      ? [
                          _vm.slideIndexCarousel > 0
                            ? _c("i", {
                                staticClass:
                                  "fa-sharp fa-solid fa-circle-chevron-left",
                                on: { click: _vm.prevIndexCarousel },
                              })
                            : _vm._e(),
                          _vm.slideIndexCarousel + 1 < _vm.medias.length
                            ? _c("i", {
                                staticClass:
                                  "fa-sharp fa-solid fa-circle-chevron-right",
                                on: { click: _vm.nextIndexCarousel },
                              })
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _c(
                      "carousel",
                      {
                        ref: "carousel",
                        attrs: {
                          perPage: 1,
                          adjustableHeight: true,
                          centerMode: true,
                        },
                        on: { pageChange: _vm.slideChangeCarousel },
                      },
                      _vm._l(_vm.medias.slice(0, 20), function (media, index) {
                        return _c("Slide", { key: media.id }, [
                          _c(
                            "div",
                            { staticClass: "item" },
                            [
                              media.info.type.startsWith("video/")
                                ? [
                                    _c("video", {
                                      staticClass: "video",
                                      attrs: {
                                        preload: "metadata",
                                        onloadedmetadata: "this.muted = true",
                                        playsinline: "",
                                        autoplay: "",
                                        loop: "",
                                        src: media.url,
                                        type: media.info.type,
                                      },
                                      domProps: {
                                        muted:
                                          _vm.slideIndexCarousel !== index ||
                                          _vm.mutedSound ||
                                          _vm.music ||
                                          _vm.modes.includes("addMusicMode"),
                                      },
                                    }),
                                  ]
                                : [
                                    _c("img", {
                                      style: {
                                        //'object-fit' : media.info.width / media.info.height > 2.111111111111111 ? 'cover' : media.info.width / media.info.height > ratioCalculated.split(':').reduce((a, b) => a / b) ? 'contain' : 'cover',
                                        // 'aspect-ratio': media.info.width / media.info.height > 2.111111111111111 ? '16/9' : null
                                      },
                                      attrs: { src: media.url, alt: "" },
                                    }),
                                  ],
                            ],
                            2
                          ),
                        ])
                      }),
                      1
                    ),
                    _c("div", { staticClass: "pictograms left" }, [
                      _vm.productSlideCarousel.length
                        ? _c("div", { staticClass: "pictogram product" })
                        : _vm._e(),
                      _vm.personsIdentifiedSlideCarousel.length
                        ? _c("div", { staticClass: "pictogram user" })
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "pictograms right" }, [
                      _vm.music ||
                      (_vm.slideIndexCarousel >= 0 &&
                        _vm.medias[_vm.slideIndexCarousel] &&
                        _vm.medias[_vm.slideIndexCarousel].info.type2 ==
                          "video")
                        ? _c("div", {
                            staticClass: "pictogram",
                            class: _vm.mutedSound ? "no-sound" : "sound",
                          })
                        : _vm._e(),
                    ]),
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "post-footer" }, [
                _c("div", { staticClass: "like" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        height: "100%",
                        viewBox: "0 0 24 24",
                        width: "100%",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "comment" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        height: "100%",
                        viewBox: "0 0 24 24",
                        width: "100%",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z",
                          fill: "none",
                          stroke: "#000000",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm.text
                ? _c("div", { staticClass: "description" }, [
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "text" }, [
                        _c("span", { staticClass: "page-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.pages.length > 1
                                ? "Auteur"
                                : _vm.pages[0].name
                            )
                          ),
                        ]),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.textTranslateMentionAndHastag
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._l(_vm.commentsTranslateMentionAndHastag, function (comment) {
                return _c("div", { staticClass: "first-comment" }, [
                  _c("div", { staticClass: "img-pages" }, [
                    _c("div", { staticClass: "page" }, [
                      _c("img", {
                        attrs: {
                          src:
                            !_vm.pages ||
                            !_vm.pages.length ||
                            _vm.pages.length > 1 ||
                            !_vm.pages[0]
                              ? "img/avatar.jpg"
                              : _vm.pages[0].avatar,
                          alt: "",
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "content" }, [
                    _c("p", { staticClass: "page-name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.pages.length > 1 ? "Auteur" : _vm.pages[0].name
                        )
                      ),
                    ]),
                    _c("p", {
                      staticClass: "text",
                      domProps: { innerHTML: _vm._s(comment) },
                    }),
                  ]),
                  _c("i", { staticClass: "fa-regular fa-heart" }),
                ])
              }),
            ],
            2
          ),
        ]
      ),
      _vm.modes.includes("addIdentifierMode")
        ? _c("SelectPerson", {
            attrs: {
              personsSelect: _vm.personsIdentified,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
              maxPersons: 10,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
      _vm.modes.includes("addCollaboratorMode")
        ? _c("SelectPerson", {
            attrs: {
              personsSelect: _vm.collaborators,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
              maxPersons: 5,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
      _vm.modes.includes("addPlaceMode")
        ? _c("SelectPlace", {
            attrs: {
              placeSelected: _vm.place,
              position: _vm.positionFormOverlay,
              network: "instagram",
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
      _vm.modes.includes("addMusicMode")
        ? _c("SelectMusic", {
            attrs: {
              musicSelected: _vm.music,
              position: _vm.positionFormOverlay,
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
      _vm.modes.includes("addProductMode")
        ? _c("SelectProduct", {
            attrs: {
              productsSelect: _vm.products,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "more" }, [
      _c("i", { staticClass: "fa-solid fa-ellipsis" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }